import { PayloadAction } from '@reduxjs/toolkit';

import { State } from '../types/state';

const setUserGeoPositionLoading = (state: State, action: PayloadAction<State['geoPosition']['loadingStatus']>) => {
  state.geoPosition.loadingStatus = action.payload;
};

export default setUserGeoPositionLoading;
